import React, { useState } from 'react';
import styled from 'styled-components';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';

const IconButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    transition: all 0.3s ease;
    color: ${props => props.fill ? '#0f766e' : '#999'};
    font-size: 24px;

    &:hover {
        background: rgba(15, 118, 110, 0.1);
        color: #0f766e;
        transform: scale(1.15);
        box-shadow: 0 2px 8px rgba(15, 118, 110, 0.2);
    }

    &:active {
        transform: scale(0.95);
    }
`;

function LikeThumb(props) {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <IconButton
            fill={props.fill}
            onClick={() => props.clickEvent()}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            title={props.fill ? 'Remove like' : 'Like this scene'}
        >
            {props.fill ? (
                <ThumbUpIcon sx={{ fontSize: '24px' }} />
            ) : (
                <ThumbUpOutlinedIcon sx={{ fontSize: '24px' }} />
            )}
        </IconButton>
    );
}

export default LikeThumb;